import React from 'react';
import { assetUrl } from '../../utils/url';

export type ActivityItem = {
  id: number | string;
  title: string;
  image_url?: string | null;
  start_time: string;
  location?: string | null;
};

const ActivitiesList: React.FC<{
  items: ActivityItem[];
}> = ({ items }) => {
  const list = Array.isArray(items) ? items.slice(0, 4) : [];
  return (
    <div className="blog-list">
      {list.map((e) => (
        <a key={e.id} href={`/aktivita/${e.id}`} className="card" style={{ textDecoration: 'none', color: 'inherit' }}>
          <div className="thumb" style={{ backgroundImage: `url(${assetUrl(e.image_url) || '/images/news/placeholder.jpg'})` }} />
          <div>
            <h4>{e.title}</h4>
            <div style={{ color: 'var(--dark-gray)', fontSize: '0.9rem' }}>
              {new Date(e.start_time).toLocaleDateString()} {e.location ? `• ${e.location}` : ''}
            </div>
          </div>
        </a>
      ))}
    </div>
  );
};

export default ActivitiesList;
